import owd from 'owd/owd';
import 'lib/dropkick';

export default class Select extends owd.Component {
	init() {
		this.select = new Dropkick(this.$element[0]);
	}

    destroy() {
		this.select.dispose();
        super.destroy();
    }
}

owd.registerComponent('select', {
	component: Select
});
